import { render, staticRenderFns } from "./NewsletterPage.vue?vue&type=template&id=213a3c82&scoped=true&"
import script from "./NewsletterPage.vue?vue&type=script&lang=js&"
export * from "./NewsletterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a3c82",
  null
  
)

export default component.exports